import { useState, useEffect } from 'react';
import { getSetting, SettingsItem } from '../services/SettingsService';

export function useExtensionUrl() {
    const [extensionUrl, setExtensionUrl] = useState<string>("");
    
    useEffect(() => {
        const fetchExtensionUrl = async () => {
            try {
                const url = await getSetting(SettingsItem.ExtensionUrl);
                setExtensionUrl(url);
            } catch (err) {
                console.error("Failed to fetch extension URL:", err);
            }
        };


        fetchExtensionUrl().then();
    }, []);

    return extensionUrl;
}